module.exports = __webpack_public_path__ + "images/5f804d83ef1af5c42851010a82e892e3.png";